<template>
  <v-app class="">
    <router-view></router-view>
    <v-footer app color="grey lighten-4">
      <span class="ml-4 text-caption"
        >© 2018 Management Resources Consultants, All Rights Reserved</span
      >
    </v-footer>
  </v-app>
</template>

<script lang="js">
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['queryCurrency', 'queryAccessRight']),
  },
  created() {
    this.queryCurrency();
    this.queryAccessRight();
    if (this.$router.currentRoute.path === '/') {
      this.$router.push('/public/details');
    } else if (this.$router.currentRoute.path === '/public/' || this.$router.currentRoute.path === '/public') {
      this.$router.push('/public/details');
    }
  },
};
</script>

<style lang="scss"></style>
